import { useEffect } from 'react';
import { hideBreadCrumbs, showBreadCrumbs } from './update-crumb';

// 进入的时候隐藏面包屑导航，离开的时候重置面包屑导航的展示
export default function useHideBreadCrumbs() {
  useEffect(() => {
    hideBreadCrumbs();
    return showBreadCrumbs;
  }, []);
}
